import React from "react";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Scroll } from "lucide-react";

import s from "./AppLayout.css";
import { Header, Link } from "../../components";
import { Button, Layout, Menu, Icon, Tooltip } from "antd";
import antStyles from "antd/dist/antd.less";
import globalStyles from "../../global.css";
const { SubMenu } = Menu;
const { Sider } = Layout;
import { HOME_ROUTE } from "../../routes";
import history from "../../history";
import paginationStyles from "react-horizontal-scrolling-menu/dist/styles.css";
import { handleStripePortalRedirect } from "../../reducers/user";
import {
  AROMATHERAPY,
  PROMPT_TOOL,
  MOBILE_WIDTH_LIMIT,
  AI_ASSISTANT,
  AI_CONTENT_CREATOR,
  TOFU,
  MOFU,
  BOFU,
  IMAGE_GENERATOR_FEATURE,
} from "../../constants";
import { hasFeature } from "../../utils";
import { clearForms } from "../../reducers/product";
import BuyAssistant from "./BuyAssistant";
const regex_cosmode = /cosmode/;
import Footer from "../Footer/Footer";
import UpgradeNotification from "./UpgradeNotification";

class AppLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      showSider: false,
      mounted: false,
      isTooltipVisible: false,
      openSubMenus: [],
      selectedKeys: [], // Initialize as empty, will be set in componentDidMount
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.iframeRef = React.createRef();
  }

  // Determine selectedKey from path
  getSelectedKeyFromPath = (path) => {
    if (!path) return [];

    // Strip leading slash and map to menu keys
    const pathWithoutSlash = path.substring(1);

    // Map paths to corresponding menu keys
    const pathToKeyMap = {
      chatbot: ["assistant"],
      chatfiles: ["files"],
      prompttool: ["prompttool"],
      bizcomm: ["bizcomm"],
      myprompts: ["myprompts"],
      aicontentcreator: ["aicontentcreator"],
      artstyles: ["artstyles"],
      guides: ["guides"],
      help: ["help"],
      about: ["about"],
      account: ["Manage"],
      logout: ["logout"],
    };

    // Return the mapped key or empty array if not found
    return pathToKeyMap[pathWithoutSlash] || [];
  };

  componentDidMount() {
    window.addEventListener("message", this.handleYouTubeMessage);
    window.addEventListener("resize", this.updateWindowDimensions);

    // Now that we're on the client side, we can safely access history
    if (typeof window !== "undefined" && history && history.location) {
      this.setState({
        selectedKeys: this.getSelectedKeyFromPath(history.location.pathname),
      });

      // Listen for history changes to update selected key
      this.unlisten = history.listen((location) => {
        this.setState({
          selectedKeys: this.getSelectedKeyFromPath(location.pathname),
        });
      });
    }

    this.updateWindowDimensions();
    this.setState({
      mounted: true,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleYouTubeMessage);
    window.removeEventListener("resize", this.updateWindowDimensions);

    // Clean up history listener
    if (this.unlisten) {
      this.unlisten();
    }
  }

  handleOpenChange = (openKeys) => {
    // Get the newly opened submenu (the last item in the array)
    const latestOpenKey = openKeys.length > 0 ? openKeys[openKeys.length - 1] : null;

    // If there is a newly opened key, set only that one as open
    if (latestOpenKey) {
      this.setState({ openSubMenus: [latestOpenKey] });
    } else {
      // If no keys, close all submenus
      this.setState({ openSubMenus: [] });
    }
  };

  handleMenuClick = (path) => {
    // Push to new route
    history.push(path);

    // Update selectedKeys based on the path
    this.setState({
      selectedKeys: this.getSelectedKeyFromPath(path),
    });

    // Collapse sider if on mobile
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) {
      this.setState({
        collapsed: true,
      });
    }
  };

  handleYouTubeMessage = (event) => {
    if (event.origin !== "https://www.youtube.com") return;

    if (event.data && typeof event.data === "string") {
      try {
        const data = JSON.parse(event.data);
        if (data.event === "onStateChange" && data.info === 0) {
          // Video has ended, you can handle this if needed
        }
      } catch (error) {
        console.error("Error parsing YouTube message:", error);
      }
    }
  };

  handleTooltipVisibilityChange = (visible) => {
    this.setState({ isTooltipVisible: visible }, () => {
      this.controlYouTubeVideo();
    });
  };

  controlYouTubeVideo = () => {
    try {
      const iframe = this.iframeRef.current;
      if (iframe) {
        const contentWindow = iframe.contentWindow;
        if (this.state.isTooltipVisible) {
          contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        } else {
          contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
        }
      }
    } catch (error) {
      console.error("Error in controlYouTubeVideo:", error);
    }
  };

  // In your component
  handleSubMenuClick = (key) => {
    const { openSubMenus } = this.state;
    const isOpen = openSubMenus.includes(key);

    // For mobile, ensure the sider stays open when submenus are clicked
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) {
      this.setState({
        collapsed: false, // Keep the sider expanded
        openSubMenus: isOpen ? openSubMenus.filter((k) => k !== key) : [...openSubMenus, key],
      });
    } else {
      this.setState({
        openSubMenus: isOpen ? openSubMenus.filter((k) => k !== key) : [...openSubMenus, key],
      });
    }
  };
  handleAIAssistantClick = () => {
    // Open the submenu
    const key = "ai-assistant-submenu";
    if (!this.state.openSubMenus.includes(key)) {
      this.setState({
        openSubMenus: [...this.state.openSubMenus, key],
      });
    }

    // Navigate to the Assistant page
    this.handleMenuClick("/chatbot");
  };

  handlePromptsClick = () => {
    const key = "all-prompts";
    if (!this.state.openSubMenus.includes(key)) {
      this.setState({
        openSubMenus: [...this.state.openSubMenus, key],
      });
    }

    // Navigate to the Assistant page
    this.handleMenuClick("/prompttool");
  };

  handleGraphicsClick = () => {
    const key = "graphics";
    if (!this.state.openSubMenus.includes(key)) {
      this.setState({
        openSubMenus: [...this.state.openSubMenus, key],
      });
    }

    // Navigate to the Assistant page
    this.handleMenuClick("/artstyles");
  };

  handleHelpMenuClick = () => {
    const key = "helpmenu";
    if (!this.state.openSubMenus.includes(key)) {
      this.setState({
        openSubMenus: [...this.state.openSubMenus, key],
      });
    }

    // Navigate to the Assistant page
    this.handleMenuClick("/guides");
  };

  getSiderWidth = () => {
    // Get the computed style of the root element (or any element that has the variable applied)
    // Check if window exists (browser environment)
    if (typeof window !== "undefined") {
      const styles = getComputedStyle(document.documentElement);

      // Get the specific CSS variable
      const siderWidth = styles.getPropertyValue("--sider-width").trim();

      // If you need it as a number without 'px'
      const siderWidthValue = parseInt(siderWidth, 10);

      return siderWidthValue || 260; // Return the default if it's not found
    } else {
      return 260;
    }
  };

  manageSubscription = () => {
    this.props.handleStripePortalRedirect();
  };

  updateWindowDimensions = (event) => {
    if (typeof window !== "undefined") {
      const isDesktop = window.innerWidth > MOBILE_WIDTH_LIMIT;
      this.setState({
        windowWidth: window.innerWidth,
        collapsed: !isDesktop, // Collapsed on mobile, open on desktop
      });
    }
  };

  toggle = () => {
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) {
      // Only toggle on mobile and ensure sider is visible
      this.setState({
        collapsed: !this.state.collapsed,
        showSider: true, // Add this to ensure sider is shown
      });
    }
  };

  getName = () => {
    if (!this.props || !this.props.user) return "";
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) return "";
    const email = this.props.user.email;
    const fname = this.props.user.first_name;
    const lname = this.props.user.last_name;
    if (fname.length > 0 && lname.length > 0) {
      return `${fname} ${lname}`;
    } else if (fname.length > 0) {
      return `${fname}`;
    } else {
      return `${this.props.user.first_name} ${this.props.user.last_name}`;
    }
  };

  getLogo = (sider_width) => {
    const logoimg = (
      <img className={s.logoimg} src="https://ai-grimm.nyc3.cdn.digitaloceanspaces.com/grimm_logo.webp" alt={"logo"} loading="lazy" />
    );

    if (sider_width == 0) {
      return <span onClick={this.toggle}>{logoimg}</span>;
    } else if (this.props.currentRouteName === HOME_ROUTE) {
      return logoimg;
    } else {
      return <Link to={HOME_ROUTE}>{logoimg}</Link>;
    }
  };

  handleClickOutside = async (event) => {
    if (this.node && this.node.contains(event.target)) {
      return;
    }

    await this.setState({ collapsed: true });
  };

  static defaultProps = {
    footer: true,
  };

  siderLeave = () => {
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) {
      // Only collapse on mobile
      this.setState({
        collapsed: true,
      });
    }
  };

  siderEnter = () => {
    if (this.state.windowWidth <= MOBILE_WIDTH_LIMIT) {
      // Only expand on mobile
      this.setState({
        collapsed: false,
      });
    }
  };

  render() {
    const { hideSider, footer, currencies, currentRouteName } = this.props;

    const cosmode =
      process.env.BROWSER && typeof history !== "undefined" && history.location && regex_cosmode.test(history.location.pathname);
    const user = this.props.user;
    const SIDER_WIDTH = this.getSiderWidth();

    const sider_width = this.state.windowWidth && this.state.windowWidth > MOBILE_WIDTH_LIMIT ? SIDER_WIDTH : 0;

    const sider_class = sider_width === 0 ? s.mobileForNav : s.forNav;
    const content_class = hideSider ? s.nosiderContent : s.content;

    const handleLogout = () => {
      var widget = document.getElementById("searchie-fixed-btn");
      if (widget) widget.parentNode.removeChild(widget);
      var script = document.getElementById("widget_script-fixed-btn");
      if (script) script.parentNode.removeChild(script);
    };

    const showAssistant = hasFeature(user, AI_ASSISTANT);
    const imageGenFeature = hasFeature(user, IMAGE_GENERATOR_FEATURE);
    const showAIContentCreator = hasFeature(user, AI_CONTENT_CREATOR);
    const showPromptTool = hasFeature(user, PROMPT_TOOL);
    const hasTofu = hasFeature(user, TOFU);
    const limitByTofu = !hasFeature(user, TOFU);
    const limitByMofu = !hasFeature(user, MOFU);
    const limitByBofu = hasFeature(user, BOFU);

    const name = this.getName();

    return (
      <Layout className={s.container}>
        {this.state.mounted && currencies && (
          <React.Fragment>
            <div>
              {!hideSider && this.props.user != null && (
                <React.Fragment>
                  <div className={s.leftmenu} ref={(node) => (this.node = node)}>
                    <div className={s.topleftnav}>
                      <div className={s.logo}>{this.getLogo(sider_width)}</div>
                    </div>

                    <div className={s.username}>
                      <div>{name}</div>
                    </div>
                    {this.props.user != null && (
                      <div className={sider_class}>
                        <Sider
                          className={s.sider}
                          collapsible={this.state.windowWidth <= MOBILE_WIDTH_LIMIT} // Only collapsible on mobile
                          width={sider_width} // Add this line to explicitly set width to 250px
                          collapsedWidth={sider_width > 0 ? sider_width : 260}
                          collapsed={this.state.collapsed}
                          onMouseLeave={this.siderLeave}
                          onMouseEnter={this.siderEnter}
                          trigger={null}
                        >
                          <>
                            <Menu
                              mode="inline"
                              className={s.menuMobileTop}
                              theme="light"
                              selectedKeys={this.state.selectedKeys}
                              openKeys={this.state.openSubMenus}
                              onOpenChange={this.handleOpenChange}
                            >
                              {showAssistant ? (
                                <SubMenu
                                  key="ai-assistant-submenu"
                                  title={
                                    <span>
                                      <Scroll size={18} />
                                      <span>MY ASSISTANT</span>
                                    </span>
                                  }
                                  className={s.ant_menu_horizontal}
                                  onTitleClick={this.handleAIAssistantClick}
                                >
                                  <Menu.Item
                                    key="assistant"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/chatbot")}
                                  >
                                    <span>Chat</span>
                                  </Menu.Item>
                                  <Menu.Item
                                    key="files"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/chatfiles")}
                                  >
                                    <span>My Files</span>
                                  </Menu.Item>
                                </SubMenu>
                              ) : (
                                <Menu.Item key="assistant" className={s.ant_menu_horizontal}>
                                  <Tooltip
                                    placement="left"
                                    align={{
                                      offset: [30, 30],
                                    }}
                                    title={
                                      <div style={{ width: "295px" }}>
                                        <UpgradeNotification />
                                      </div>
                                    }
                                  >
                                    <span style={{ color: "#C6C6C6" }}>AI Assistant</span>
                                  </Tooltip>
                                </Menu.Item>
                              )}

                              <SubMenu
                                key="all-prompts"
                                title={
                                  <span>
                                    <Scroll size={18} />
                                    <span>PROMPTS</span>
                                  </span>
                                }
                                className={s.ant_menu_horizontal}
                                onTitleClick={this.handlePromptsClick}
                              >
                                {(showPromptTool || hasTofu) && (
                                  <Menu.Item
                                    key="prompttool"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/prompttool")}
                                  >
                                    <span>Business Prompts</span>
                                  </Menu.Item>
                                )}
                                <Menu.Item key="bizcomm" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/bizcomm")}>
                                  <span>Course Prompts</span>
                                </Menu.Item>
                                {/* {showAssistant ? ( */}
                                {/*   <Menu.Item */}
                                {/*     key="myprompts" */}
                                {/*     className={s.ant_menu_horizontal} */}
                                {/*     onClick={() => this.handleMenuClick("/myprompts")} */}
                                {/*   > */}
                                {/*     <span>My Prompts</span> */}
                                {/*   </Menu.Item> */}
                                {/* ) : ( */}
                                {/*   limitByTofu && ( */}
                                {/*     <Menu.Item key="myprompts" className={s.ant_menu_horizontal}> */}
                                {/*       <Tooltip */}
                                {/*         placement="left" */}
                                {/*         align={{ */}
                                {/*           offset: [30, 30], */}
                                {/*         }} */}
                                {/*         title={ */}
                                {/*           <div style={{ width: "295px" }}> */}
                                {/*             <UpgradeNotification /> */}
                                {/*           </div> */}
                                {/*         } */}
                                {/*       > */}
                                {/*         <span style={{ color: "#C6C6C6" }}>My Prompts</span> */}
                                {/*       </Tooltip> */}
                                {/*     </Menu.Item> */}
                                {/*   ) */}
                                {/* )} */}

                                {showAIContentCreator && (
                                  <Menu.Item
                                    key="aicontentcreator"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/aicontentcreator")}
                                  >
                                    <span>Content Creator</span>
                                  </Menu.Item>
                                )}
                              </SubMenu>
                              <SubMenu
                                key="course"
                                title={
                                  <span>
                                    <Scroll size={18} />
                                    <span>COURSE</span>
                                  </span>
                                }
                                className={s.ant_menu_horizontal}
                                onTitleClick={() => this.handleSubMenuClick("course")}
                              >
                                <Menu.Item
                                  key="lessons"
                                  className={s.ant_menu_horizontal}
                                  onClick={() =>
                                    window.open("https://www.skool.com/ai-grimm-society/classroom", "_blank", "noopener,noreferrer")
                                  }
                                >
                                  <span>Lessons</span>
                                </Menu.Item>
                                <Menu.Item
                                  key="courseprompts"
                                  className={s.ant_menu_horizontal}
                                  /* onClick={() => this.handleMenuClick("/bizcomm")} */
                                  onClick={() => window.open("https://studio.aigrimm.com", "_blank", "noopener,noreferrer")}
                                >
                                  <span>Prompts</span>
                                </Menu.Item>
                                <Menu.Item
                                  key="community"
                                  className={s.ant_menu_horizontal}
                                  onClick={() => window.open("https://www.skool.com/ai-grimm-society", "_blank", "noopener,noreferrer")}
                                >
                                  <span>Community</span>
                                </Menu.Item>
                              </SubMenu>

                              <SubMenu
                                key="graphics"
                                title={
                                  <span>
                                    <Scroll size={18} />
                                    <span>GRAPHICS</span>
                                  </span>
                                }
                                className={s.ant_menu_horizontal}
                                onTitleClick={this.handleGraphicsClick}
                              >
                                {showAssistant ? (
                                  <Menu.Item
                                    key="artstyles"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/artstyles")}
                                  >
                                    <span>Art Styles</span>
                                  </Menu.Item>
                                ) : (
                                  <Menu.Item key="artstyles" className={s.ant_menu_horizontal}>
                                    <Tooltip
                                      placement="left"
                                      align={{
                                        offset: [30, 30],
                                      }}
                                      title={
                                        <div style={{ width: "295px" }}>
                                          <UpgradeNotification />
                                        </div>
                                      }
                                    >
                                      <span style={{ color: "#C6C6C6" }}>Art Styles</span>
                                    </Tooltip>
                                  </Menu.Item>
                                )}
                                {showAssistant ? (
                                  <Menu.Item
                                    key="replicate-image"
                                    className={s.ant_menu_horizontal}
                                    onClick={() => this.handleMenuClick("/replicate-image")}
                                  >
                                    <span>Image Generator</span>
                                  </Menu.Item>
                                ) : (
                                  <Menu.Item key="replicate-image" className={s.ant_menu_horizontal}>
                                    <Tooltip
                                      placement="left"
                                      align={{
                                        offset: [30, 30],
                                      }}
                                      title={
                                        <div style={{ width: "295px" }}>
                                          <UpgradeNotification />
                                        </div>
                                      }
                                    >
                                      <span style={{ color: "#C6C6C6" }}>Art Styles</span>
                                    </Tooltip>
                                  </Menu.Item>
                                )}
                              </SubMenu>

                              <Menu.Divider style={{ marginTop: "20px", marginBottom: "20px" }} />

                              <SubMenu
                                key="helpmenu"
                                title={
                                  <span>
                                    <Scroll size={18} />
                                    <span>HELP</span>
                                  </span>
                                }
                                className={s.ant_menu_horizontal}
                                onTitleClick={this.handleHelpMenuClick}
                              >
                                <Menu.Item key="guides" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/guides")}>
                                  <span>Starter Guides</span>
                                </Menu.Item>

                                <Menu.Item key="help" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/help")}>
                                  <span>Support</span>
                                </Menu.Item>
                              </SubMenu>

                              <Menu.Item key="about" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/about")}>
                                <Scroll size={18} />

                                <span>About</span>
                              </Menu.Item>

                              <Menu.Item key="Manage" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/account")}>
                                <Scroll size={18} />

                                <span>My Account</span>
                              </Menu.Item>
                              <Menu.Item key="logout" className={s.ant_menu_horizontal} onClick={() => this.handleMenuClick("/logout")}>
                                <Scroll size={18} />

                                <span>Sign out</span>
                              </Menu.Item>
                            </Menu>
                          </>
                        </Sider>
                        <Header toggleSider={this.toggle} />
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
            <Layout.Content className={content_class}>{this.props.children}</Layout.Content>
          </React.Fragment>
        )}
        <Footer />
      </Layout>
    );
  }
}

const mapState = (state) => ({
  user: state.user.user,
  currencies: state.global.currencies,
  currentRouteName: state.global.currentRouteName,
});

const mapDispatch = {
  clearForms,
  handleStripePortalRedirect,
};

export default connect(mapState, mapDispatch)(withStyles(antStyles, paginationStyles, globalStyles, s)(AppLayout));
